import axiosInstance from '../../api/api';
import { API_ROUTES } from '../../config/api-routes';
import { normalizePublicProfile } from '../../utils/normalizePublicProfile';
import { shareTokenQuery } from '../../utils/publicProfileAccess';

export const fetchUserData = async (
  username: string,
  shareToken?: string | null,
  options?: { asRecruiterToken?: boolean }
) => {
  try {
    const response = await axiosInstance.get(
      `${API_ROUTES.CANDIDATE.GET_CANDIDATE}/${encodeURIComponent(username)}${shareTokenQuery(shareToken, options)}`
    );
    return normalizePublicProfile(response.data as Record<string, unknown>);
  } catch (error) {
    console.error('Error fetching candidate data:', error);
    return null;
  }
};

// import axios from 'axios';
// import { API_ROUTES } from '../../config/api-routes';

// export const fetchUserData = async (username: string) => {
//   try {
//     const API = 'http://localhost:5001/';
//     const response = await axios.get(
//       `${API}${API_ROUTES.USER.GET_USER_PUBLIC}/${username}`,
//     );

//     const { user } = response.data;
//     console.log('Fetched user data:', user);
//     return user;
//   } catch (error: any) {
//     console.error('Error fetching user data:', error);
//   }
// };
